// @hooks
import { useUrlData } from './useUrlData';
import { useRequests } from './useRequests';

// @types
import { ICommittedCapacityContext } from '../types';

export function useCommittedCapacityState(): ICommittedCapacityContext {
  const urlData = useUrlData();
  const { carrierId, shouldBeBooked, tenderNumber } = urlData;
  const requestsData = useRequests({ carrierId, shouldBeBooked, tenderNumber });

  return { ...requestsData, ...urlData };
}
